import { render, staticRenderFns } from "./instockReport.vue?vue&type=template&id=54b84904&scoped=true&"
import script from "./instockReport.vue?vue&type=script&lang=js&"
export * from "./instockReport.vue?vue&type=script&lang=js&"
import style0 from "./instockReport.vue?vue&type=style&index=0&id=54b84904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b84904",
  null
  
)

export default component.exports